import {
  MantineTheme,
  PaperProps,
  PartialVarsResolver,
  PaperFactory,
  useMantineColorScheme
} from '@mantine/core';

import classes from './Paper.module.css';

export const PaperOverridesClassNames = () => {
  return {
    root: classes.root
  };
};

export const PaperVarsResolver: PartialVarsResolver<PaperFactory> = (
  theme: MantineTheme,
  props: PaperProps
) => {
  const scheme = useMantineColorScheme();
  if (props.shadow === 'xs') {
    return {
      root: {
        '--paper-shadow': 'none'
      }
    };
  } else if (props.shadow === 'sm' && scheme.colorScheme === 'light') {
    return {
      root: {
        '--paper-shadow': '0px 2px 2px rgba(235, 238, 240, 0.4)'
      }
    };
  }

  return {
    root: {}
  };
};

export const DefaultPaperProps: Partial<PaperProps> = {
  radius: 'md',
  shadow: 'sm',
  p: 'xl',
  withBorder: true
};
